import './bookoverview.css'

import overviewImg from '../../../../assets/img/libro/bookOverview.jpg'

const BookOverview = () => {
  return (
    <section className='bookOverview section__padding'>

      {/* BLOQUE SUPERIOR */}
      <div className='bookOverview__top'>

        <div className='bookOverview__image'>
          <img src={overviewImg} alt='Diversidad de mujeres' />
        </div>

        <div className='bookOverview__highlight'>
          <p>
            <em>Educación Menstrual </em>&nbsp;inaugura un campo educativo propio al definir, por primera vez, el rol, los fundamentos y los enfoques de la educadora menstrual, desde una escritura colectiva de mujeres hispanohablantes.
          </p>
        </div>

      </div>

      {/* BLOQUE INFERIOR */}
      <div className='bookOverview__content'>
        
        <h2 className='bookForYou__title'>
          ¿De qué va este libro?
        </h2>

        <p>
          <em>Educación Menstrual </em>&nbsp;es una obra colectiva que articula
          pensamiento crítico, práctica educativa e investigación científica para
          abordar la menstruación, el ciclo vital y los derechos menstruales desde
          una perspectiva feminista, interseccional e internacional.
        </p>

        <p>
          El libro recoge saberes situados, experiencias pedagógicas y marcos
          teóricos que reconocen la menstruación como un hecho biológico, social,
          político y cultural, atravesado por múltiples factores de desigualdad
          e inequidad.
        </p>
      </div>

    </section>
  )
}

export default BookOverview
